import { useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";

interface UsePrintProps {
  documentTitle?: string
  pageSize?: string;
  fontSize?: string;
  backgroundColor?: string;
  color?: string;
  onAfterPrint?: VoidFunction;
}

interface PrintParams {
  content: string;
}

const usePrint = ({
  documentTitle,
  onAfterPrint,
  pageSize,
  fontSize,
  backgroundColor = '#ffffff',
  color = '#1e1e1e',
}: UsePrintProps) => {
  const printContentRef = useRef(null);

  const [printContent, setPrintContent] = useState<PrintParams>()

  const reactToPrintFn = useReactToPrint({
    contentRef: printContentRef,
    documentTitle: documentTitle,
    pageStyle: `
        @media print {
          @page { size: ${pageSize} !important; margin: 0 !important; }
          html {
            height: auto !important;
            min-height: auto !important;
            max-height: none !important;
          }
          body {
            height: auto !important;
            min-height: auto !important;
            max-height: none !important;
            margin: 0 !important;
            font-size: ${fontSize};
            background-color: ${backgroundColor};
            color: ${color};
          }
        }
        @media print and (max-width: 190mm) {
          body {
            size: 70mm auto;
            font-size: 5px;
          }
        }
      `,
    onAfterPrint() {
      setPrintContent(undefined);

      onAfterPrint?.();
    },
  });

  const print = ({ content }: PrintParams) => {
    setPrintContent({ content })

    setTimeout(() => {
      reactToPrintFn();
    });
  }

  return {
    print,
    contextProps: {
      ref: printContentRef,
      content: printContent?.content || '',
      backgroundColor,
      color,
    },
  }
}

export default usePrint;
